/**
 * Scenario Compare Reducer
 * State shape: { data: ScenarioCompareResponse | null, loading: boolean, error: object | null }
 */
import produce from "immer";
import {
  SCENARIO_COMPARE_REQUEST,
  SCENARIO_COMPARE_SUCCESS,
  SCENARIO_COMPARE_ERROR,
  SCENARIO_COMPARE_RESET,
} from "../types";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

/**
 * Scenario Compare Reducer
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
function scenarioCompareReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SCENARIO_COMPARE_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.error = null;
      });

    case SCENARIO_COMPARE_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.data = payload;
        draft.error = null;
      });

    case SCENARIO_COMPARE_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.error = payload;
      });

    case SCENARIO_COMPARE_RESET:
      return initialState;

    default:
      return state;
  }
}

export default scenarioCompareReducer;

/**
 * Selectors
 */
export const selectScenarioCompareData = (state) => state.scenarioCompare?.data;
export const selectScenarioCompareLoading = (state) => state.scenarioCompare?.loading;
export const selectScenarioCompareError = (state) => state.scenarioCompare?.error;
